<div class="hero-content">
  <div class="background-content {{ loading ? 'loading' : '' }}">
    <img
      class="background-image"
      [ngSrc]="heroImageSig()"
      placeholder
      priority
      fill="true"
      sizes="(max-width:768px) 90vw, 70vw"
      [alt]="movie()?.title + ' hero image'"
    />

    @if (embed() && hasTrailerSig() && playing()) {
      <ush-video
        #video
        [content]="movie()"
        (videoReady)="onEmbedVideoReady()"
        [embed]="false"
        [controls]="false"
        [mute]="muted()"
        [autoplay]="autoplay()"
        [trackingCategory]="trackingCategory"
      ></ush-video>
    }
  </div>
  <ush-loading-indicator *ngIf="loading" position="absolute"></ush-loading-indicator>
  <div class="hero-controls control-buttons">
    @if (!disableMovieInfo) {
      <div class="hero-info">
        <img
          *ngIf="logoUrl && logoSizes"
          class="video-thumbnail-logo"
          [ngSrc]="logoUrl"
          [sizes]="logoSizes.sizes"
          [height]="logoSizes.height"
          [width]="logoSizes.width"
          [style]="logoSizes.style"
          priority="true"
          [alt]="'video thumbnail image of ' + movie()?.title"
        />
        <h2 *ngIf="!logoUrl">{{ titleSig() }}</h2>
        <p *ngIf="releaseMessageSig()">{{ releaseMessageSig() }}</p>
      </div>
    }

    <div class="hero-buttons">
      <p-button class="cta-button" *ngIf="ctaButtonLabel" [label]="ctaButtonLabel" (click)="onCtaClick()">
        <ng-template pTemplate="icon">
          <fa-icon *ngIf="seeMoreEnabled" [icon]="playIcon"></fa-icon>
        </ng-template>
      </p-button>

      @if (!disableTrailer && hasTrailerSig()) {
        @if (embedVideoControls()) {
          <!-- play pause buttons -->
          <div class="play-pause-controls">
            <fa-icon (click)="onPauseButtonClick()" [icon]="pauseIcon"></fa-icon>
            @if (autoplay()) {
              <fa-icon (click)="unmuteVideo()" [icon]="unmuteIcon"></fa-icon>
            } @else {
              <fa-icon (click)="muteVideo()" [icon]="muteIcon"></fa-icon>
            }
          </div>
        } @else {
          <p-button
            class="trailer-button ctrl-play"
            cookies-check
            [cookiesRequired]="cookiesRequired"
            label="Watch trailer"
            i18n-label="@@movie-template-a.menu.watchTrailer"
            [attr.data-translate]="'movie-template-a.menu.watchTrailer'"
            (clickAfterCheck)="onPlayTrailerClick()"
          >
            <ng-template pTemplate="icon">
              <fa-icon [icon]="playIcon"></fa-icon>
            </ng-template>
          </p-button>
        }
      }

      <!-- WATCH NOW - FULLVIDEO PARAM ///////////////////// -->
      @if (enableFullVideo()) {
        <a
          class="p-element trailer-button ctrl-play fullVideo-button"
          cookies-check
          [cookiesRequired]="cookiesRequired"
          (clickAfterCheck)="onPlayFullVideoClick()"
        >
          <div
            class="p-element p-button p-component"
            style="height: 100%"
            [attr.data-translate]="'movie-template-a.menu.watchNow'"
          >
            <span>{{ 'movie-template-a.menu.watchNow' | translate }}</span>
          </div>
        </a>
      }

      @if (additionalLink()) {
        <a class="p-element trailer-button ctrl-play fullVideo-button" target="blank" [href]="additionalLink()">
          <div
            class="p-element p-button p-component"
            style="height: 100%"
            [attr.data-translate]="'movie-template-a.menu.watchExternal'"
          >
            <span>{{ 'movie-template-a.menu.watchExternal' | translate }}</span>
          </div>
        </a>
      }
      <!-- WATCH NOW - FULLVIDEO PARAM ///////////////////// -->

      @if (hasUplayerSig()) {
        <ush-uplay-button *ngIf="movie() as movie" [movie]="movie"></ush-uplay-button>
      }
    </div>
  </div>
  <ng-content selector="[hero-footer]"></ng-content>
</div>
